__turbopack_context__.v({
  "blueDot": "CategorySidebar-module__us7xnG__blueDot",
  "categoryItem": "CategorySidebar-module__us7xnG__categoryItem",
  "categoryNav": "CategorySidebar-module__us7xnG__categoryNav",
  "categoryText": "CategorySidebar-module__us7xnG__categoryText",
  "separator": "CategorySidebar-module__us7xnG__separator",
  "sidebar": "CategorySidebar-module__us7xnG__sidebar",
  "sidebarDescription": "CategorySidebar-module__us7xnG__sidebarDescription",
  "sidebarHeader": "CategorySidebar-module__us7xnG__sidebarHeader",
  "sidebarTitle": "CategorySidebar-module__us7xnG__sidebarTitle",
});
